import { zodResolver } from '@hookform/resolvers/zod'
import { ArrowLeft } from 'lucide-react'
import { FC, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import appStore from 'src/assets/product-config/app-store.png'
import background from 'src/assets/product-config/background-signin.png'
import android from 'src/assets/product-config/google-play.png'
import { api } from 'src/services/api'
import { z } from 'zod'
import { Plan } from '../createAccountWalletInitials/account_wallet_create'
import { FormInput, FormSelectInput } from './components'

const FormSchemaRG = z.object({
  documentNumber: z.string({
    required_error: 'Insira o número do RG.',
  }),

  shippingDate: z.string({
    required_error: 'Insira a Data de Expedição do RG',
  }),
})

const FormSchemaCNH = z.object({
  documentNumber: z.string({
    required_error: 'Insira o número da CNH.',
  }),
  shippingDate: z.string({
    required_error: 'Insira a Data de Expedição da CNH',
  }),
  expirationDate: z.string({
    required_error: 'Insira a Data de Vencimento da CNH',
  }),
})

type FormInputsRG = z.infer<typeof FormSchemaRG>
type FormInputsCNH = z.infer<typeof FormSchemaCNH>

export const ChoosePlan: FC = () => {
  const location = useLocation()
  const { accountType } = location.state

  const [plans, setPlans] = useState<Plan[]>([])

  const navigate = useNavigate()

  const { control, handleSubmit } = useForm<FormInputsRG>({
    resolver: zodResolver(FormSchemaRG),
  })

  const { control: controlCNH, handleSubmit: handleSubmitCNH } =
    useForm<FormInputsCNH>({
      resolver: zodResolver(FormSchemaCNH),
    })

  const [currentDocumentSelected, setCurrentDocumentSelected] = useState('')

  const onSubmitRG = async (data: FormInputsRG) => {
    const planData = {
      ...data,
      planId: plans[0]?.id,
    }
    try {
      localStorage.setItem('@yntech:signup-data-02', JSON.stringify(planData))
      navigate('/create-account-wallet/insert-account-address', {
        state: { accountType },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onSubmitCNH = async (data: FormInputsCNH) => {
    const planData = {
      ...data,
      planId: plans[0]?.id,
    }
    try {
      localStorage.setItem('@yntech:signup-data-02', JSON.stringify(planData))
      navigate('/create-account-wallet/insert-account-address', {
        state: { accountType },
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchPlans = async () => {
    try {
      const response = await api.get('/graphic/plans', {
        params: {
          role: 'WALLET',
        },
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      })

      setPlans(response.data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchPlans()
  }, [])

  return (
    <div
      style={{
        backgroundImage: `url(${background})
	`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
      className="w-full flex-col h-screen flex justify-center items-center gap-20"
    >
      <button
        onClick={() => navigate('/create-account-wallet/choose-account-type')}
        className="h-12 w-12 absolute left-10 top-10 flex items-center justify-center rounded-xl bg-zinc-950 shadow-sm"
      >
        <ArrowLeft size={22} color="white" />
      </button>
      <div className="flex flex-col absolute bottom-10 left-10">
        <span className="text-white text-xl font-bold">Baixe o nosso app,</span>
        <span className="text-white text-xl">
          disponível nas principais lojas
        </span>
        <div className="flex gap-2 mt-2">
          <img
            alt=""
            src={android}
            className="w-[150px] object-contain cursor-pointer"
          />
          <img
            alt=""
            src={appStore}
            className="w-[150px] object-contain cursor-pointer"
          />
        </div>
      </div>
      <div className="bg-black mr-10 self-end bg-opacity-40 rounded-3xl backdrop-filter backdrop-blur-md border border-gray-600 p-12 min-w-[480px] max-w-[600px] flex flex-col justify-center items-center">
        <div className="w-full ">
          <div className="w-full flex items-start gap-10">
            <p className="font-medium text-white text-xl xl:text-2xl full-hd:text-3xl 3xl-hd:text-4xl qhd:text-5xl studio-laptop:text-6xl qhd-plus:text-6xl 4k:text-8xl 5k:text-8xl leading-7">
              Selecione o plano <br />
              para concluir:
            </p>
          </div>

          <p className="text-white text-base xl:text-lg font-light mt-3 mb-4 max-2xl:text-xs">
            Planos disponíveis:
          </p>

          <div className="flex flex-col gap-2 items-center justify-center">
            <div className="bg-zinc-900 text-sm font-bold text-white w-full border border-amber-400 h-14 flex items-center p-4 rounded-md max-2xl:h-32">
              Plano Smart conta Wallet -
              <span className="text-amber-400 ml-1">R$0,00/mês</span>
            </div>
            <div className="bg-zinc-900 text-sm font-bold text-white w-full border border-zinc-200 h-14 flex items-center p-4 rounded-md max-2xl:h-32">
              Plano Full Conta Wallet -
              <span className="text-amber-400 ml-1">R$0,00/mês</span>
            </div>
          </div>

          <FormSelectInput
            placeholder="Tipo de documento"
            options={documentDropdownData}
            style={{
              marginTop: '8px',
              height: '6vh',
            }}
            onChanged={(e) => {
              setCurrentDocumentSelected(e.target.value)
            }}
          />

          {currentDocumentSelected === 'CNH' && (
            <form onSubmit={handleSubmitCNH(onSubmitCNH)}>
              <div>
                <Controller
                  name="documentNumber"
                  control={controlCNH}
                  render={({ field, fieldState }) => (
                    <FormInput
                      onChangeText={(e) => field.onChange(e)}
                      placeholder="Número da CNH"
                      required
                      style={{
                        height: '5.5vh',
                      }}
                      {...field}
                      mask="99999999999"
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />

                <Controller
                  name="shippingDate"
                  control={controlCNH}
                  render={({ field, fieldState }) => (
                    <FormInput
                      onChangeText={(e) => field.onChange(e)}
                      placeholder="Data de Expedição da CNH"
                      required
                      style={{
                        height: '5.5vh',
                      }}
                      {...field}
                      type="number"
                      mask="99/99/9999"
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />

                <Controller
                  name="expirationDate"
                  control={controlCNH}
                  render={({ field, fieldState }) => (
                    <FormInput
                      onChangeText={(e) => field.onChange(e)}
                      placeholder="Data de Vencimento da CNH"
                      required
                      style={{
                        height: '5.5vh',
                      }}
                      {...field}
                      type="number"
                      mask="99/99/9999"
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />
              </div>

              <div className="flex flex-col w-full gap-2 items-center justify-between mt-4">
                <button
                  className="bg-white h-16 w-full border border-zinc-300 rounded-md font-bold"
                  onClick={handleSubmitCNH(onSubmitCNH)}
                >
                  Próximo
                </button>
                <button
                  className="bg-zinc-900 h-16 w-full border border-zinc-300 rounded-md font-bold text-white"
                  onClick={() => navigate('/create-account-wallet/insert-data')}
                >
                  Voltar
                </button>
              </div>
            </form>
          )}

          {currentDocumentSelected === 'RG' && (
            <form onSubmit={handleSubmit(onSubmitRG)}>
              <div>
                <Controller
                  name="documentNumber"
                  control={control}
                  render={({ field, fieldState }) => (
                    <FormInput
                      onChangeText={(e) => field.onChange(e)}
                      placeholder="Número do RG"
                      required
                      style={{
                        height: '5.5vh',
                      }}
                      {...field}
                      mask="99.999.999-9"
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />

                <Controller
                  name="shippingDate"
                  control={control}
                  render={({ field, fieldState }) => (
                    <FormInput
                      onChangeText={(e) => field.onChange(e)}
                      placeholder="Data de Expedição do RG"
                      required
                      style={{
                        height: '5.5vh',
                      }}
                      {...field}
                      type="number"
                      mask="99/99/9999"
                      errorMessage={fieldState.error?.message}
                    />
                  )}
                />
              </div>

              <div className="flex flex-col w-full gap-2 items-center justify-between mt-4">
                <button
                  className="bg-white h-16 w-full border border-zinc-300 rounded-md font-bold"
                  onClick={handleSubmit(onSubmitRG)}
                >
                  Próximo
                </button>
                <button
                  className="bg-zinc-900 h-16 w-full border border-zinc-300 rounded-md font-bold text-white"
                  onClick={() => navigate('/create-account-wallet/insert-data')}
                >
                  Voltar
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}

const documentDropdownData = ['RG', 'CNH']
